import React, { useState } from "react";
// custom component
import General from "interventions/accordions/general";
import Parcelles from "interventions/accordions/parcelles";
import PrixDeVente from "interventions/accordions/prixDeVente";
import Produits from "interventions/accordions/produits";
import Recolte from "interventions/accordions/recolte";
import Charges from "interventions/accordions/charges";
import Materiel from "interventions/accordions/materiel";
import MainOeuvre from "interventions/accordions/mainOeuvre";
import Details from "interventions/accordions/details";
import FicheChantier from "interventions/accordions/ficheChantier/component";
// react-bootstrap components
import { Card, Collapse } from "react-bootstrap";
// react-icons
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
// intervention helper
import { Helper } from "interventions/helpers.js";
// global context (this.props.data)
import { WithContext } from "store/DataProvider";

const cardBordersFix = {
  borderBottom: "0px",
  borderTop: "1px solid rgba(0, 0, 0, 0.125)"
};

const Accordions = ({ interventionTypeId, isUpdate, isEditable, data, create }) => {
  const accordionsData = [
    {
      title: "Général",
      child: <General />,
      isVisible: true
    },
    {
      title: "Parcelles",
      child: <Parcelles />,
      isVisible: true
    },
    {
      title: "Prix de vente",
      child: <PrixDeVente />,
      isVisible: Helper.isPrixDeVente(interventionTypeId)
    },
    {
      title: "Produits",
      child: <Produits />,
      isVisible: Helper.isProduits(interventionTypeId)
    },
    {
      title: "Récolte",
      child: <Recolte />,
      isVisible: Helper.isRecolte(interventionTypeId)
    },
    {
      title: "Charges",
      child: <Charges />,
      isVisible: Helper.isCharges(interventionTypeId)
    },
    {
      title: "Matériel",
      child: <Materiel />,
      isVisible: Helper.isMateriel(interventionTypeId)
    },
    {
      title: "Main d'oeuvre",
      child: <MainOeuvre />,
      isVisible: Helper.isMainOeuvre(interventionTypeId)
    },
    {
      title: "Détails de l'intervention",
      child: <Details />,
      isVisible: true
    },
    {
      title: "Fiche de chantier",
      child: <FicheChantier />,
      // En modification (isUpdate), attendre que l'intervention soit chargée (create.intervention.id existe)
      // pour que FicheChantier initialise son state avec les bonnes valeurs
      isVisible: Helper.isFicheChantier(interventionTypeId, data.parametres.eta) && (!isUpdate || create.intervention.id)
    }
  ];

  const [accordions, setAccordions] = useState(
    accordionsData.map(accordion => (isUpdate ? true : false))
  );

  const toggle = index => {
    let newAccordions = [...accordions];
    newAccordions[index] = !newAccordions[index];
    setAccordions(newAccordions);
  };

  return accordionsData.map((accordion, index) => {
    const { title, child, isVisible } = accordion;
    const isOpen = accordions[index];
    const icon = isOpen ? (
      <FaChevronUp size={20} />
    ) : (
      <FaChevronDown size={20} />
    );
    return (
      isVisible && (
        <div key={index} className="w-100">
          <Card onClick={() => toggle(index)} style={cardBordersFix}>
            <Card.Header
              className="d-flex justify-content-between align-items-center text-center"
              style={{ height: "60px" }}
            >
              <div />
              <h5 className="mb-0"> {title} </h5>
              {icon}
            </Card.Header>
          </Card>
          <Collapse in={isOpen}>
            <div>
              {React.cloneElement(child, {
                isOpen: isOpen,
                isEditable: isEditable,
                data: data,
                create: create,
              })}
            </div>
          </Collapse>
        </div>
      )
    );
  });
};

export default WithContext(Accordions);
